<template>
<Popup
  class="top_shop_rules_half_popup"
  :title="$t('FoodC_shoprank_OYFZ_jaot' /** rules */)"
  :isShow="true"
  @clickMask="$emit('clickMask')"
  >
  <div class="content" slot="content">
    <div v-for="(rule, index) in rules" :key="index">
      <!-- introduction -->
      <div v-if="index===0" class="introduction">
        <div class="title">{{rule.title}}</div>
        <div class="sub_title">{{rule.content}}</div>
      </div>
      <!-- rankrules -->
      <div v-if="index===1" class="rank_rules">
        <div class="title">{{rule.title}}</div>
        <div class="list">
          <div v-for="(item, rIndex) in rule.rankRules" :key="rIndex" class="item">
            <div class="title">{{item.subTitle}}</div>
            <div class="sub_title">{{item.content}}</div>
          </div>
        </div>
      </div>
      <!-- rankrules -->
      <div v-if="index===2" class="rank_rules">
        <div class="title">{{rule.title}}</div>
        <div class="list">
          <div v-for="(item, rIndex) in rule.faqRules" :key="rIndex" class="item">
            <div class="title">{{item.subTitle}}</div>
            <div class="sub_title">{{item.content}}</div>
          </div>
        </div>
      </div>
      <!-- FAQ -->
      <!-- <div v-if="index===2" class="FAQ">
        <div class="title">{{rule.title}}</div>
        <div class="sub_title">{{rule.subTitle}}</div>
        <div class="content">{{rule.content}}</div>
      </div> -->
    </div>
    <rich-button @click="$emit('clickMask')">{{$t('FoodC_shoprank_Qwab_yWBb' /** got it */)}}</rich-button>
  </div>
</Popup>
</template>
<script>
import HalfPopup from '@/components/half-popup/index'
import Popup from '@/components/vant-popup'
export default {
  components: {
    HalfPopup,
    Popup
  },
  props: {
    rules: {
      type: Array,
      default: []
    }
  }
}
</script>
<style>
.top_shop_rules_half_popup .half-content{
  height: fit-content !important;
  overflow: auto;
}
</style>
<style lang="scss" scoped>
.top_shop_rules_half_popup {
  .half-content {
    height: 29.248rem !important;
  }
  .content {
    padding-top: 58px;
  }
  .introduction {
    .title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #000000;
      letter-spacing: 0;
      font-weight: 700;
    }
    .sub_title {
      margin-top: 24px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #000000;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .rank_rules {
    margin-top: 48px;
    .title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #000000;
      letter-spacing: 0;
      font-weight: 700;
    }
    .item {
      margin-top: 24px;
      .title {
        font-family: DiDiSans-Pro-Bold;
        font-size: 24px;
        color: #FF8040;
        letter-spacing: 0;
        font-weight: 700;
      }
      .sub_title {
        margin-top: 16px;
        font-family: DiDiSans-Pro-Regular;
        font-size: 24px;
        color: #000000;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
  }
  .FAQ {
    .title {
      margin-top: 48px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #000000;
      letter-spacing: 0;
      font-weight: 700;
    }
    .sub_title {
      margin-top: 24px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #FF8040;
      letter-spacing: 0;
      font-weight: 700;
    }
    .content {
      margin-top: 16px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #000000;
      letter-spacing: 0;
      font-weight: 400;
      padding-top: 0;
    }
  }
  .rich-btn {
    margin-top: 72px;
  }
}
</style>